import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { LOYALTY_LANDING_PAGE } from 'loyalty/constants/loyaltyRoutes'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import React from 'react'
import { useIntl } from 'react-intl'
import Table from 'LuxKit/Tables/Table'
import TableHeader from 'LuxKit/Tables/TableHeader'
import TableHeaderCell from 'LuxKit/Tables/TableHeaderCell'
import TableHeaderRow from 'LuxKit/Tables/TableHeaderRow'
import TableBody from 'LuxKit/Tables/TableBody'
import TableBodyCell from 'LuxKit/Tables/TableBodyCell'
import TableBodyRow from 'LuxKit/Tables/TableBodyRow'
import { isLuxLoyaltyEnabledInAgentHub } from 'agentHub/selectors/agentHubSelectors'

function LoyaltyGenericInfoModal() {
  const intl = useIntl()
  const programDisplayName = getLoyaltyProgramDisplayName()
  const person = isLuxLoyaltyEnabledInAgentHub ? 'the customer' : 'you'
  const programName = getLoyaltyProgramDisplayName()

  const title = intl.formatMessage({
    id: '4DEQPcssIU',
    defaultMessage: 'Earning points, status credits & nights',
    description: 'Modal title for loyalty earning info',
  })
  const subtitle = intl.formatMessage(
    {
      id: 'qdde3KLM5L',
      defaultMessage: 'As a member of {programDisplayName}, {person} can earn points, status credits and nights on eligible bookings.',
      description: 'Modal subtitle explaining loyalty membership benefits',
    },
    { programDisplayName, person },
  )
  const findOutMoreText = isLuxLoyaltyEnabledInAgentHub ? undefined : intl.formatMessage({
    id: '8LR3TQo1rd',
    defaultMessage: 'Find out more',
    description: 'Secondary action button to learn more about loyalty program',
  })
  const pointsSectionHeading = intl.formatMessage(
    {
      id: 'KCzuoRCIuO',
      defaultMessage: '{programName} Points',
      description: 'Section heading for loyalty points',
    },
    { programName },
  )
  const pointsDescription = intl.formatMessage({
    id: 'cHNrMvWEfI',
    defaultMessage: 'Earn and redeem points on hotels, tours, flights, cruises and more.',
    description: 'Description of loyalty points usage',
  })
  const statusCreditsSectionHeading = intl.formatMessage(
    {
      id: 'sBQb22NYo2',
      defaultMessage: '{programName} Status Credits & Nights',
      description: 'Section heading for status credits and nights',
    },
    { programName },
  )
  const statusCreditsDescription = intl.formatMessage({
    id: 'owYVDiXDtx',
    defaultMessage: 'Collect status credits and nights to move up tiers and unlock rewards including room upgrades, airport transfers, lounge passes and more.',
    description: 'Description of status credits and nights benefits',
  })
  const tierHeader = intl.formatMessage({
    id: 'zTGp3mKoVZ',
    defaultMessage: 'Tier',
    description: 'Table header for loyalty tier column',
  })
  const statusCreditsHeader = intl.formatMessage({
    id: '/hNiwfFDWL',
    defaultMessage: 'Status Credits',
    description: 'Table header for status credits column',
  })
  const nightsHeader = intl.formatMessage({
    id: 'ziHOvlLREn',
    defaultMessage: 'Nights',
    description: 'Table header for nights column',
  })
  const silverTier = intl.formatMessage({
    id: '8hSvdgUFPH',
    defaultMessage: 'Silver',
    description: 'Loyalty tier name',
  })
  const goldTier = intl.formatMessage({
    id: 'lNSf/5apfx',
    defaultMessage: 'Gold',
    description: 'Loyalty tier name',
  })
  const platinumTier = intl.formatMessage({
    id: 'M2HT+/CHed',
    defaultMessage: 'Platinum',
    description: 'Loyalty tier name',
  })

  return <Modal
    title={title}
    subtitle={subtitle}
    secondaryActionText={findOutMoreText}
    secondaryActionTo={isLuxLoyaltyEnabledInAgentHub ? undefined : `/${LOYALTY_LANDING_PAGE}`}
    secondaryActionTarget="_blank"
  >
    <Group direction="vertical" gap={16}>
      <BodyText variant="medium" weight="bold">{pointsSectionHeading}</BodyText>
      <BodyText variant="medium">
        {pointsDescription}
      </BodyText>

      <BodyText variant="medium" weight="bold">{statusCreditsSectionHeading}</BodyText>
      <BodyText variant="medium">
        {statusCreditsDescription}
      </BodyText>

      <Table>
        <TableHeader>
          <TableHeaderRow>
            <TableHeaderCell>{tierHeader}</TableHeaderCell>
            <TableHeaderCell>{statusCreditsHeader}</TableHeaderCell>
            <TableHeaderCell>{nightsHeader}</TableHeaderCell>
          </TableHeaderRow>
        </TableHeader>
        <TableBody>
          <TableBodyRow>
            <TableBodyCell>{silverTier}</TableBodyCell>
            <TableBodyCell>200</TableBodyCell>
            <TableBodyCell>10</TableBodyCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableBodyCell>{goldTier}</TableBodyCell>
            <TableBodyCell>600</TableBodyCell>
            <TableBodyCell>20</TableBodyCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableBodyCell>{platinumTier}</TableBodyCell>
            <TableBodyCell>1000</TableBodyCell>
            <TableBodyCell>30</TableBodyCell>
          </TableBodyRow>
        </TableBody>
      </Table>
    </Group>
  </Modal>
}

export default LoyaltyGenericInfoModal
